import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-activate-account',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule],
  templateUrl: './activate-account.component.html',
  styleUrl: './activate-account.component.scss'
})
export class ActivateAccountComponent implements OnInit {
  activateForm: FormGroup;
  loading = false;
  error = '';
  token = '';
  tokenValid = false;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.activateForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required]]
    }, { validator: this.passwordMatchValidator });
  }

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token') || '';
    this.tokenValid = this.token.length >= 20;

    if (!this.tokenValid) {
      this.error = 'Token de activacion invalido o ausente.';
    }
  }

  passwordMatchValidator(form: FormGroup) {
    const password = form.get('password');
    const confirmPassword = form.get('confirmPassword');

    if (password && confirmPassword && password.value !== confirmPassword.value) {
      confirmPassword.setErrors({ passwordMismatch: true });
    } else if (confirmPassword?.errors?.['passwordMismatch']) {
      delete confirmPassword.errors['passwordMismatch'];
      if (Object.keys(confirmPassword.errors).length === 0) {
        confirmPassword.setErrors(null);
      }
    }
    return null;
  }

  async onSubmit(): Promise<void> {
    if (this.activateForm.invalid || !this.tokenValid) {
      return;
    }

    this.loading = true;
    this.error = '';

    const { password } = this.activateForm.value;

    try {
      const response = await this.authService.activateAccount(this.token, password);

      if (response.success) {
        this.router.navigate(['/dashboard']);
      } else {
        this.error = response.message || 'Error al activar la cuenta';
      }
    } catch (error: any) {
      this.error = error.message || 'Error al activar la cuenta';
    } finally {
      this.loading = false;
    }
  }

  get f() {
    return this.activateForm.controls;
  }
}
